let initialState = {};

if (typeof window !== "undefined") {
  initialState = {
    userInfo: JSON.parse(localStorage.getItem("userInfoData")) || null,
    isVip: false,
    messageData: null,
    isWhiteHeader: false,
    isScriptLoaded: false,
    isLargeScreen: document.body.clientWidth > 964,
    showAuthModal: false,
    signType: "login"
  };
}

export default initialState;
